<template>
  <main class="btn-container">
    <p class="-ntr">Delete Project</p>
  </main>
</template>

<script>
export default {};
</script>

<style scoped>
.btn-container {
  position: relative;
  width: 240px;
  height: 40px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  background: var(--error);
  cursor: pointer;
  transition: all 200ms ease-in-out;
  user-select: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.btn-container > p {
  color: var(--white1);
  padding-left: 16px;
}
/* EFFECTS */
.btn-container:hover {
  transform: translateX(16px);
  box-shadow: rgba(50, 50, 93, 0.5) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.6) 0px 1px 3px -1px;
  /* transform: translateY(-8px); */
}

/*=== MEDIA QUERIES ===*/

@media screen and (max-width: 1024px) {
  .btn-container:hover {
    transform: scale(1.05);
  }
}
</style>